import { settlementMethodFormat } from '@/utils/form';
import { request } from '@/utils/request';
import {
  SettlementListFilters,
  SettlementFilters,
  formattedCount,
  SettlementListResponse,
  SettlementSummary
} from './interface';

/** [정산] 목록 조회 */
export const getOrdersSettlements = async (
  token: string,
  params: SettlementListFilters
): Promise<SettlementListResponse> => {
  const { from, to, phone, username, page, limit } = params;

  const {
    data: { result }
  } = await request(token).get('/settlements/pharmacy-details', {
    params: {
      from,
      to,
      phone,
      username,
      page,
      limit
    }
  });
  return result;
};

/** [정산] 요약 조회 (금액) */
export const getSettlementsSummary = async (
  token: string,
  params: SettlementFilters
): Promise<SettlementSummary> => {
  const { from, to, phone, username } = params;

  const {
    data: { result }
  } = await request(token).get('/settlements/pharmacy-summary', {
    params: {
      from,
      to,
      phone,
      username
    }
  });
  return result;
};

/** [정산] 요약 조회 (타입별 카운트) */
export const getSettlementsCountbyType = async (
  token: string,
  params: SettlementFilters
): Promise<formattedCount> => {
  const { from, to, phone, username } = params;

  const {
    data: { result }
  } = await request(token).get('/settlements/pharmacy-sum-by-type', {
    params: {
      from,
      to,
      phone,
      username
    }
  });

  return settlementMethodFormat(result);
};

/** [정산] 상세 내역 엑셀 다운로드 (타입별 카운트) */
export const onDownloadExcel = async (
  token: string,
  params: SettlementFilters
) => {
  const { from, to } = params;

  const excel = await request(token).get(
    '/settlements/pharmacy-details/download',
    {
      responseType: 'blob',
      params: {
        from,
        to
      }
    }
  );

  return excel;
};

export default {
  getOrdersSettlements,
  getSettlementsSummary,
  getSettlementsCountbyType,
  onDownloadExcel
};
